import * as React from 'react';
import { SeparatedOfferings } from 'selectors/calendarSelectors';
import { TockProductType } from '@tock/shared/types/productFeatures';
import { consumer, core } from '@tock/coretypes';
import { hasMultipleOfferingTypes } from 'utils/offerings';
import { useLocation } from 'react-router';
import ConsumerProductFeatureRestriction from 'components/product/ConsumerProductFeatureRestriction';
import OpenTableExternalLink from 'components/business/landing-page/OpenTableExternalLink';
import SeparatedExperiencesJump from 'components/business/offerings-lists/SeparatedExperiencesJump';

interface Props {
  business: consumer.IBusinessConfig;
  hasOfferings?: boolean;
  isLoading?: boolean;
  isWidget?: boolean;
  nextRelease?: core.IBookingRelease;
  onAddTicketTypeToWaitlist(experienceId?: number): void;
  separatedOfferings?: SeparatedOfferings;
  soldOut?: boolean;
  ticketGroups: consumer.ICalendarTicketGroup[];
}

const Offerings: React.FunctionComponent<Props> = ({
  business,
  hasOfferings,
  isWidget,
  nextRelease,
  onAddTicketTypeToWaitlist,
  separatedOfferings,
  soldOut,
  ticketGroups,
}) => {
  const location = useLocation();
  const multipleOfferingTypes = separatedOfferings
    ? hasMultipleOfferingTypes(separatedOfferings)
    : false;

  React.useEffect(() => {
    if (location.hash.length > 0) {
      const hashvalue = location.hash.substr(1);
      if (typeof window !== 'undefined') {
        setTimeout(() => {
          const panel = document.getElementById(`${hashvalue}-panel`);
          if (panel) {
            const tabsAdjustment = 44;
            window.scrollTo(0, panel.offsetTop - (multipleOfferingTypes ? tabsAdjustment : 0));
          }
        }, 20); // trying to ensure it happens after scroll memory happens :(
      }
    }
  }, [location.hash, multipleOfferingTypes]);

  return (
    <>
      {business.externalReservationsUrl && (
        <OpenTableExternalLink href={business.externalReservationsUrl} />
      )}

      {separatedOfferings && (
        <ConsumerProductFeatureRestriction onlyForProductType={TockProductType.CLASSIC}>
          {({ pass: isClassicCustomer }) => (
            <SeparatedExperiencesJump
              business={business}
              hasOfferings={hasOfferings}
              pickup={separatedOfferings.pickup}
              delivery={separatedOfferings.delivery}
              shipping={separatedOfferings.shipping}
              events={separatedOfferings.events}
              nextRelease={nextRelease}
              onAddToWaitlist={onAddTicketTypeToWaitlist}
              reservations={separatedOfferings.reservations}
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              showWaitlist={business.showWaitlist! && isClassicCustomer}
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              soldOut={soldOut!}
              ticketGroups={ticketGroups}
              hasMultipleOfferingTypes={multipleOfferingTypes}
              isWidget={isWidget}
              container={isWidget ? () => document.querySelector('.ConsumerModal-body') : undefined}
            />
          )}
        </ConsumerProductFeatureRestriction>
      )}
    </>
  );
};

export default Offerings;
